import { connect } from 'react-redux';
import { flow, get, pick, values, reject, getOr, first } from 'lodash/fp';

import loading from '../../actions/loading';
import loaded from '../../actions/loaded';
import InstallationOnlyModal from './InstallationOnlyModal';
import globalError from '../../actions/globalError';
import { convertDesignToJob } from '../../api/mandi';
import getInstallationPricing from '../../helpers/installationPricing';

const mapStateToProps = ({ estimateBuilder }, { designId }) => {
  const textOptInNumber = flow(
    getOr('{}', `entities.estimates.byId.${designId}.attributes.customer`),
    JSON.parse,
    get('phones'),
    first,
    getOr('', 'number'),
  )(estimateBuilder);

  const containerIds = get(`entities.estimates.byId.${designId}.containers`, estimateBuilder);
  const specMappings = get('mandiAvailability.specMappings', estimateBuilder);

  const containers = flow(
    get('entities.containers.byId'),
    pick(containerIds),
    values,
    reject('isDeleted'),
  )(estimateBuilder);

  const updatePricing = (leafItems, attributes) =>
    convertDesignToJob(
      designId,
      leafItems,
      attributes,
      { cancellationKey: `${designId}-installationOnly`, mode: 'transient' },
    ).then((job) => {
      const charges = get('pricingResult.charges', job);

      return getInstallationPricing(charges, specMappings);
    });

  return {
    textOptInNumber,
    containers,
    updatePricing,
  };
};
const mapDispatchToProps = dispatch => ({
  setLoading: value => (value
    ? dispatch(loading())
    : dispatch(loaded())
  ),
  globalError: err => dispatch(globalError({ err })),
});
export default connect(mapStateToProps, mapDispatchToProps)(InstallationOnlyModal);
